import styled from "styled-components";

export const Flexbox = styled.div`
  display: flex;
`;

export const ColumnList = styled.ol`
  flex: 50%;
`;
